import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Footer({ setMostrarPopupContacto }) {
  const [enviado, setEnviado] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const data = new FormData(form);
    const response = await fetch("https://formspree.io/f/mzzgjekw", {
      method: "POST",
      body: data,
      headers: {
        Accept: "application/json",
      },
    });

    if (response.ok) {
      setEnviado(true);
      form.reset();
    }
  };

  return (
    <footer className="bg-[#355f60] text-white py-10 mt-12 border-t border-[#2d4f51] shadow-inner">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Columna 1 - Formulario */}
        <div>
          <h2 className="font-bold mb-2 uppercase text-white">Habla con nosotros</h2>
          <p className="text-sm mb-4">Cuéntanos tu experiencia.</p>
        
          {enviado ? (
            <p className="text-green-300 font-medium">
              ✅ ¡Gracias por tu mensaje! Te responderemos pronto.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                type="email"
                name="email"
                required
                placeholder="Ingresa tu correo"
                className="w-full p-3 rounded bg-[#7fa9ae] text-white border border-[#5c7f83] placeholder-white/80 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent"
              />
              <textarea
                name="mensaje"
                required
                rows="3"
                placeholder="Escribe tus comentarios..."
                className="w-full p-3 rounded bg-[#7fa9ae] text-white border border-[#5c7f83] placeholder-white/80 focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent"
              ></textarea>
              <button
                type="submit"
                className="bg-white text-empresarial px-4 py-2 rounded-md hover:bg-gray-100 transition font-medium"
              >
                Enviar mensaje
              </button>
            </form>
          )}
        </div>

        {/* Columna 2 - Enlaces */}
        <div className="text-center md:text-left">
          <h2 className="font-bold mb-2 uppercase text-white">Explora</h2>
          <ul className="space-y-2 text-sm">
            <li>
              <button
                onClick={() => {
                  navigate("/catalogo?categoria=");
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 300);
                }}
                className="hover:underline underline-offset-4 text-left"
              >
                Ver todo el catálogo
              </button>
            </li>
            <li>
              <button
                onClick={() => setMostrarPopupContacto(true)}
                className="hover:underline underline-offset-4"
              >
                Contacto
              </button>
            </li>
            <li>
              <span className="text-blue-200">📧 ventas@proveedoraempresarial.com</span>
            </li>
            <li>
              <span className="text-blue-200">📞 2474-6975 / 2368-4387</span>
            </li>
            <li>
              <div className="mt-4 flex justify-center md:justify-start items-center gap-3">
                <a
                  href="https://www.instagram.com/tu_usuario"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200 hover:text-white transition"
                >
                  {/* Ícono de Instagram */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5ZM12 7a5 5 0 1 1 0 10a5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7Zm4.88-.88a.88.88 0 1 1 0 1.75a.88.88 0 0 1 0-1.75Z" />
                  </svg>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-6 text-center text-xs text-blue-200">
        &copy; {new Date().getFullYear()} Proveedora Empresarial. Todos los derechos reservados.
        <p className="mt-2">
          Página creada por{" "}
          <a
            href="https://aquode.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:text-white transition"
          >
            aquode.com
          </a>
        </p>
      </div>
    </footer>
  );
}

